var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-content markdown-body"},[_c('a-spin',{attrs:{"tip":"数据加载中...","spinning":_vm.loading}},[_c('div',{staticClass:"doc-list"},[_vm._v(" 关于我 "),(false)?_c('VueMarkdown',{ref:"mdContent",attrs:{"source":_vm.planInfo,"toc":true,"highlight":true}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }